/** Parses "mm:ss", "m:ss", "95:39" (minutes may pass 59) or "h:mm:ss". Returns seconds, or null. */
export function parseTime(input: string): number | null {
  const m = input.trim().match(/^(\d{1,3}):(\d{2})(?::(\d{2}))?(?:[.,](\d{1,3}))?$/);
  if (!m) return null;
  const frac = m[4] ? Number('0.' + m[4]) : 0;
  if (m[3] !== undefined) {
    const h = Number(m[1]);
    const mm = Number(m[2]);
    const ss = Number(m[3]);
    if (mm > 59 || ss > 59) return null;
    return h * 3600 + mm * 60 + ss + frac;
  }
  const mm = Number(m[1]);
  const ss = Number(m[2]);
  if (ss > 59) return null;
  return mm * 60 + ss + frac;
}

const pad = (n: number) => String(n).padStart(2, '0');

/** Video time, always h:mm:ss: 1:09:32. */
export function formatVideoTime(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  return `${Math.floor(s / 3600)}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
}

/** Match clock, mm:ss with minutes past 59 kept: 95:39. */
export function formatClock(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  return `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;
}

/** Clip length: "12 s". */
export function formatSeconds(sec: number): string {
  return `${Math.round(sec)} s`;
}

/** Reel length: "14:36" or "1:02:03". */
export function formatTotal(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  if (s >= 3600) return formatVideoTime(s);
  return `${Math.floor(s / 60)}:${pad(s % 60)}`;
}

/** "About 2 min" style estimate for time left. */
export function formatEta(sec: number): string {
  if (!isFinite(sec) || sec <= 0) return 'Almost done';
  if (sec < 60) return `About ${Math.max(5, Math.round(sec / 5) * 5)} s left`;
  const min = Math.round(sec / 60);
  return `About ${min} min left`;
}

export function periodName(p: number): string {
  if (p === 1) return '1st';
  if (p === 2) return '2nd';
  if (p === 3) return 'ET 1';
  if (p === 4) return 'ET 2';
  return `P${p}`;
}
